<template>
  <div class="container">
    <div class="menu-top">
      <navMenu></navMenu>
      <div class="banner">
        <img src="../assets/images/Garment.jpg">
        <div class="banner-title font-large">
          <span>GARMENT</span>
        </div>
      </div>
      <div class="ad-area">
        <div class="ad-top">
          <div class="ad-items ad-top-l">
            <img src="../assets/images/School uniform.jpg">
            <span class="font-normal">SCHOOL UNIFORM</span>
          </div>
          <div class="ad-items ad-top-r">
            <img src="../assets/images/Custom Made.jpg">
            <span class="font-normal">CUSTOM MADE</span>
          </div>
        </div>
        <div class="ad-bottom ad-items">
          <img src="../assets/images/Fabric.jpg">
          <span class="font-normal">FABRIC</span>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
export default {
  data () {
    return {
      
    }
  },
  components: {
    NavMenu,
    Footer
  },
  methods: {
  },
  watch: {},
  mounted () { }
}
</script>
<style lang="less" scoped>
  .container{
    width: 100%;
    height: 100%;
    
    .menu-top{
      .banner{
        width: 100%;
        position: relative;
        margin-bottom: 30px;
        z-index: -1;
        img{
          width: 100%;
        }
        .banner-title{
          font-weight: bold;
          color: #131313;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          span{
            padding: 0 20px;
            border-top: 2px solid #131313;
            border-bottom: 2px solid #131313;
          }
        }
      }
      .ad-area{
        margin: 0 auto;
        .ad-items{
          img{
            width: 100%;
          }
          span{
            color: #333;
            // font-size: 30px;
            font-weight: bold;
          }
        }
        .ad-top{
          display: flex;
          margin-bottom: 20px;
          .ad-top-l{
            // width: 50%;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 20px;
            img{
              margin-bottom: 10px;
            }
          }
          .ad-top-r{
            // flex: 1;
            width: 50%;
            position: relative;
            span{
              position: absolute;
              color: #fff;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .ad-bottom{
          position: relative;
          span{
            position: absolute;
            color: #fff;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

  }
  @media (min-width: 1400px) {
    .container .ad-area{
      width: 63%;
    }
    
  }
  @media screen and (min-width: 1025px) and (max-width: 1399px) {
    .container .ad-area{
      width: 63%;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .container .ad-area{
      width: 80%;
    }
    .banner{
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 767px) {
    .container .ad-area{
      width: 100%;
    }
    .ad-top{
      padding: 0 12px;
    }
    .banner{
      margin-top: 72px;
    }
  }
</style>
